import {
  InAppNotificationEventData,
  useAmplitude,
} from 'src/context/AmplitudeProvider';
import { EventNamesMap } from 'src/context/AmplitudeProvider';
import useStoreSlug from 'src/common/hooks/useStoreSlug';
import { InAppNotification } from 'src/types/common';
import useAuthContext from 'src/context/AuthProvider/useAuthContext';
import { useCallback } from 'react';
import { useFeatureValue } from '@growthbook/growthbook-react';
import { FEATURE_FLAGS } from 'src/utils/growthBook/growthBook.constants';

const useTrackInAppNotificationEvents = () => {
  const { logEvent } = useAmplitude();
  const { user } = useAuthContext();
  const { storeSlug } = useStoreSlug();
  const timeout = useFeatureValue(
    FEATURE_FLAGS.IN_APP_NOTIFICATIONS_DURATION,
    3
  );

  const trackNotificationClick = useCallback(
    (notification: InAppNotification) => {
      const eventData: InAppNotificationEventData = {
        email: user?.email || null,
        store_slug: storeSlug,
        ...notification,
      };

      logEvent(EventNamesMap.AppNotificationClick, eventData);
    },
    [user, storeSlug, logEvent]
  );

  const trackNotificationClose = useCallback(
    (notification: InAppNotification) => {
      const eventData: InAppNotificationEventData = {
        email: user?.email || null,
        store_slug: storeSlug,
        ...notification,
      };

      logEvent(EventNamesMap.AppNotificationClose, eventData);
    },
    [user, storeSlug, logEvent]
  );

  const trackNotificationAutoClose = useCallback(
    (notification: InAppNotification) => {
      const eventData = {
        email: user?.email || null,
        store_slug: storeSlug,
        timeout,
        ...notification,
      };

      logEvent(EventNamesMap.AppNotificationAutoClose, eventData);
    },
    [user, storeSlug, logEvent, timeout]
  );

  const trackNotificationView = useCallback(
    (notification: InAppNotification) => {
      const eventData: InAppNotificationEventData = {
        email: user?.email || null,
        store_slug: storeSlug,
        ...notification,
      };

      logEvent(EventNamesMap.AppNotificationView, eventData);
    },
    [user, storeSlug, logEvent]
  );

  return {
    trackNotificationClick,
    trackNotificationClose,
    trackNotificationAutoClose,
    trackNotificationView,
  };
};

export default useTrackInAppNotificationEvents;
